import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import VideoDetail from 'components/VideoDetail'
import { StoriesStore } from 'stores/stories'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper, getStoryKeyValues } from 'utils'

const VideoPodcastDetailPage = ({ story, videoSource, videoList, videoListTitle }) => {
  useStore(StoriesStore, { current: story, currentVideoSource: videoSource, videoList })
  useStoryPageView(story)

  const adSettings = {
    slot: 'standard-post',
    revContentSlot: 'Barstool-Original',
    keyValues: getStoryKeyValues(story)
  }
  return (
    <SiteLayout adSettings={adSettings}>
      <Head story={story} videoSource={videoSource} />
      <VideoDetail title={videoListTitle} adSettings={adSettings} />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params }) => {
  const { id } = params
  const [story, videoSource] = await Promise.all([StoriesStore().findById(id), StoriesStore().findVideoSource(id)])
  const videoList = await StoriesStore().findVideoList({ brand: story.brand_id })
  return {
    story,
    videoSource,
    videoList,
    videoListTitle: story.brand_name || 'Latest Videos'
  }
})

export default VideoPodcastDetailPage
